import { isNil } from 'lodash';

// Types.
export type ProductivitySavedFilters = {
  project: string | null;
  site: string | null;
  start: string | null;
  end: string | null;
};

// Constants.
export const PRODUCTIVITY_FILTERS_STORAGE_KEY = 'productivityDashboardFilters';

export const ProductivityFiltersManager = {
  save: (filters: ProductivitySavedFilters): void => {
    localStorage.setItem(
      PRODUCTIVITY_FILTERS_STORAGE_KEY,
      JSON.stringify(filters),
    );
  },

  get: (): ProductivitySavedFilters | null => {
    const storedFilters = localStorage.getItem(
      PRODUCTIVITY_FILTERS_STORAGE_KEY,
    );

    if (isNil(storedFilters)) {
      return null;
    }

    try {
      return JSON.parse(storedFilters);
    } catch {
      return null;
    }
  },

  remove: (): void => {
    localStorage.removeItem(PRODUCTIVITY_FILTERS_STORAGE_KEY);
  },
};
